import { SilentError } from './SilentError';

/**
 * Any core functionality-related error
 */
export class PresentableError extends SilentError {
    constructor(...args) {
        super(...args);
        this.name = 'PresentableError';
    }
}
